var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.rm.PortfolioName) +
                        " / " +
                        _vm._s(_vm.rm.ScenarioName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Plan: Selection")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [
                    _c("PortfolioScenarioNavigation", {
                      attrs: {
                        portfolioId: _vm.rm.PortfolioId,
                        corporateScenarioUrl: _vm.rm.CorporateScenarioUrl,
                      },
                      on: {
                        "selector-opened":
                          _vm.handleUpdateScenarioAcceptancesCommand,
                        "settings-opened":
                          _vm.handleUpdateScenarioAcceptancesCommand,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mt-5" },
                _vm._l(_vm.rm.Metrics, function (m) {
                  return _c(
                    "div",
                    {
                      key: m.Id,
                      staticClass: "col-sm-6 col-md-4 col-lg-3 col-xl-3",
                    },
                    [
                      _c("div", { staticClass: "card mt-2" }, [
                        _c("div", { staticClass: "card-body text-center" }, [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(m.Title) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h6",
                            { staticClass: "card-subtitle mb-2 text-muted" },
                            [_vm._v(_vm._s(m.Subtitle))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "h1" }, [
                            _vm._v(_vm._s(m.PlannedValueString ?? " ")),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "h5 text-muted" }, [
                            _vm._v(_vm._s(m.PlannedPercentageString ?? " ")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-left" }, [
                            _c("hr", { staticClass: "my-3" }),
                            _vm._v(" "),
                            _c("h6", [
                              _vm._v(
                                "All: " + _vm._s(m.RequestedValueString) + " "
                              ),
                              m.RequestedPercentageString
                                ? _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(m.RequestedPercentageString) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("h6", [
                              _vm._v(
                                "Accepted: " +
                                  _vm._s(m.AcceptedValueString ?? "NA") +
                                  " "
                              ),
                              m.AcceptedPercentageString
                                ? _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(m.AcceptedPercentageString) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("h6", [
                              _vm._v(
                                "Rejected: " +
                                  _vm._s(m.RejectedValueString ?? "NA") +
                                  " "
                              ),
                              m.RejectedPercentageString
                                ? _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(m.RejectedPercentageString) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("h6", [
                              _vm._v(
                                "TBD: " + _vm._s(m.TbdValueString ?? "NA") + " "
                              ),
                              m.TbdPercentageString
                                ? _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "(" + _vm._s(m.TbdPercentageString) + ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header pointer",
                    on: {
                      click: function ($event) {
                        _vm.resourcesSectionExpanded =
                          !_vm.resourcesSectionExpanded
                      },
                    },
                  },
                  [_c("h5", [_vm._v("Resources")])]
                ),
                _vm._v(" "),
                _vm.resourcesSectionExpanded
                  ? _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.rm.ResourceConstraints, function (r) {
                          return _c(
                            "div",
                            {
                              key: r.Id,
                              staticClass:
                                "col-sm-6 col-md-4 col-lg-3 col-xl-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card mt-1",
                                  class: _vm.getResourceCardClass(r),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "card-body text-center" },
                                    [
                                      _c("h5", { staticClass: "card-title" }, [
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "sanitizedHref",
                                                rawName: "v-sanitizedHref",
                                                value: `/#/portfolio-plan/resource/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}/${r.Id}`,
                                                expression:
                                                  "`/#/portfolio-plan/resource/${workspaceId}/${tchProjectId}/${scenarioId}/${r.Id}`",
                                              },
                                            ],
                                            staticClass: "text-dark",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(r.Name) +
                                                " "
                                            ),
                                            _c("small", [
                                              _vm._v(_vm._s(r.Unit)),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "card-subtitle mb-2 text-muted",
                                        },
                                        [
                                          r.Limit != null
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.fmtPct(
                                                        r.Allocation / r.Limit
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ])
                                            : _c("span", [_vm._v("-")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "h1" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.fmtNum(r.Allocation)) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header pointer",
                    on: {
                      click: function ($event) {
                        _vm.constraintsSectionExpanded =
                          !_vm.constraintsSectionExpanded
                      },
                    },
                  },
                  [
                    _c("h5", [
                      _vm._v("Costs (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.constraintsSectionExpanded
                  ? _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.rm.CostConstraints, function (c) {
                          return _c(
                            "div",
                            {
                              key: c.Id,
                              staticClass:
                                "col-sm-6 col-md-4 col-lg-3 col-xl-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card mt-1",
                                  class: _vm.getCostCardClass(c),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "card-body text-center" },
                                    [
                                      _c("h5", { staticClass: "card-title" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(c.Name) +
                                            "\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "card-subtitle mb-2 text-muted",
                                        },
                                        [
                                          c.Limit != null
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.fmtPct(
                                                        c.Allocation / c.Limit
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ])
                                            : _c("span", [_vm._v("-")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "h1" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.fmtNum(c.Allocation)) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card mt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header pointer",
                    on: {
                      click: function ($event) {
                        _vm.criteriaSectionExpanded =
                          !_vm.criteriaSectionExpanded
                      },
                    },
                  },
                  [_c("h5", [_vm._v("Criteria")])]
                ),
                _vm._v(" "),
                _vm.criteriaSectionExpanded
                  ? _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.topCriteria, function (c) {
                          return _c(
                            "div",
                            {
                              key: c.Id,
                              staticClass:
                                "col-sm-6 col-md-4 col-lg-3 col-xl-2",
                            },
                            [
                              _c("div", { staticClass: "card" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-body text-center" },
                                  [
                                    _c("h5", { staticClass: "card-title" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(c.Name) +
                                          "\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "h6",
                                      {
                                        staticClass:
                                          "card-subtitle mb-2 text-muted",
                                      },
                                      [_vm._v("Value points")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "h1" }, [
                                      _vm._v(
                                        _vm._s(
                                          c.TotalWeightedValueString ?? " "
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("br"),
                                      _c(
                                        "span",
                                        { staticClass: "h5 text-muted" },
                                        [_vm._v(_vm._s(c.BalanceRatioString))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-left" }, [
                                      _c("hr", { staticClass: "my-3" }),
                                      _vm._v(" "),
                                      _c("h6", [
                                        _vm._v(
                                          "Overall value: " +
                                            _vm._s(
                                              _vm.rm.TotalAcceptedValueString
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [_vm._v("(100%)")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("h6", [
                                        _vm._v(
                                          "Criterion value: " +
                                            _vm._s(c.TotalWeightedValueString) +
                                            " "
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(c.ValueShareString) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("h6", [
                                        _vm._v(
                                          "Balanced value: " +
                                            _vm._s(
                                              c.BalancedWeightedValueString
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(c.GlobalWeightString) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("h6", [
                                        _vm._v(
                                          "Balance ratio: " +
                                            _vm._s(c.BalanceRatioString)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("ProjectsSelectionView", {
                attrs: {
                  propProjects: _vm.filteredProjects,
                  propCurrencyLabel: _vm.rm.CurrencyLabel,
                  propAllCriteria: _vm.rm.Criteria,
                  propComparableScenarios: _vm.rm.ComparableScenarios,
                  propSearchPhrase: _vm.searchPhrase,
                  propProjectsFilter: _vm.projectsFilter,
                },
                on: {
                  "accept-selection": function ($event) {
                    return _vm.handleAcceptSelection($event)
                  },
                  "reject-selection": function ($event) {
                    return _vm.handleRejectSelection($event)
                  },
                  "lock-selection": function ($event) {
                    return _vm.handleLockSelection($event)
                  },
                  "unlock-selection": function ($event) {
                    return _vm.handleUnlockSelection($event)
                  },
                  "update-search-phrase": function ($event) {
                    _vm.searchPhrase = $event
                  },
                  "update-projects-filter": function ($event) {
                    _vm.projectsFilter = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-lg-6 col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "float-right" }, [
              _c("div", { staticClass: "dropdown d-inline mr-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    attrs: { "data-toggle": "dropdown" },
                  },
                  [_vm._v("Legend")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu dropdown-menu-right",
                    attrs: { role: "menu" },
                  },
                  [
                    _c("span", { staticClass: "dropdown-item-text" }, [
                      _c("i", {
                        staticClass: "fa-solid fa-xmark text-danger",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" Rejected\n                                    "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "dropdown-item-text" }, [
                      _c("i", {
                        staticClass:
                          "fa-solid fa-play fa-rotate-270 text-warning",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" TBD\n                                    "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "dropdown-item-text" }, [
                      _c("i", {
                        staticClass: "fa-solid fa-circle text-success",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" Accepted\n                                    "),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v("Efficient Frontier")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body chart-container" }, [
            _c("div", {
              staticStyle: {
                "max-width": "100%",
                height: "100%",
                overflow: "auto",
              },
              attrs: { id: "Chart-EfficientFrontier" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6 col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "float-right" }, [
              _c("div", { staticClass: "dropdown d-inline mr-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-sm",
                    attrs: { "data-toggle": "dropdown" },
                  },
                  [_vm._v("Legend")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu dropdown-menu-right",
                    attrs: { role: "menu" },
                  },
                  [
                    _c("span", { staticClass: "dropdown-item-text" }, [
                      _c("i", {
                        staticClass: "fa-solid fa-xmark text-danger",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" Rejected\n                                    "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "dropdown-item-text" }, [
                      _c("i", {
                        staticClass:
                          "fa-solid fa-play fa-rotate-270 text-warning",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" TBD\n                                    "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "dropdown-item-text" }, [
                      _c("i", {
                        staticClass: "fa-solid fa-circle text-success",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" Accepted\n                                    "),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v("Prioritization Matrix")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body chart-container" }, [
            _c("div", {
              staticStyle: {
                "max-width": "100%",
                height: "100%",
                overflow: "auto",
              },
              attrs: { id: "Chart-PrioritizationMatrix" },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }